export default __webpack_public_path__ + "static/pc1-2-b11f5f69aa42e3c22f071b1218e5a4f4.jpg";